import { useForm } from 'react-hook-form';
import { FormPasswordField, FormTextField } from '@skupreme/shared/ui/form';
import OAuthService from '@utility/services/oauth';
import { ToastMessage } from '@utility/toast';
import { ConnectPopup } from './ConnectPopup';

type SellerCloudValues = {
  sellerCloudBaseUrl: string;
  sellerCloudUsername: string;
  sellerCloudPassword: string;
};

type SellerCloudPayload = SellerCloudValues & {
  marketplace_id: string;
  marketplace_region_id: string;
  marketplace_name: string;
};

type SellerCloudConnectPopupProps = {
  open: boolean;
  onClose: () => void;
  marketplace_id: string;
  marketplace_region_id: string;
  marketplace_name: string;
  onSave: ((payload: SellerCloudPayload) => void) | undefined;
  refetch: () => void;
};

export default function SellerCloudConnectPopup({
  open,
  onClose,
  marketplace_id,
  marketplace_region_id,
  marketplace_name,
  onSave,
  refetch,
}: SellerCloudConnectPopupProps) {
  const { control, handleSubmit } = useForm<SellerCloudValues>({
    mode: 'onChange',
    defaultValues: {
      sellerCloudBaseUrl: '',
      sellerCloudUsername: '',
      sellerCloudPassword: '',
    },
  });

  const submit = handleSubmit(values => {
    const payload = {
      marketplace_id,
      marketplace_region_id,
      marketplace_name,
      ...values,
    };
    if (onSave) onSave(payload);
    OAuthService.exchange(payload)
      .then(() => {
        refetch();
        onClose();
      })
      .catch(err => {
        ToastMessage.apiError(err);
      });
  });

  if (!open) return null;

  return (
    <ConnectPopup
      open={open}
      title="Connect SellerCloud marketplace"
      onClose={onClose}
      onSubmit={submit}
      submitLabel="Save"
      size="lg"
    >
      <FormTextField
        control={control}
        name="sellerCloudBaseUrl"
        label="SellerCloud Base URL"
        placeholder="your sellercloud domain"
        isRequired
      />
      <div className="sk:grid sk:grid-cols-1 sk:gap-4 sk:sm:grid-cols-2">
        <FormTextField
          control={control}
          name="sellerCloudUsername"
          label="Username"
          placeholder="Enter username"
          isRequired
        />
        <FormPasswordField
          control={control}
          name="sellerCloudPassword"
          label="Password"
          placeholder="Enter password"
          autoComplete="current-password"
          isRequired
        />
      </div>
    </ConnectPopup>
  );
}
